import type { AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import { arrowSafe } from '@/lib/arrowSafe';

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & { href: string };

// Paths that start with "/" are pages inside this site (client-side navigation).
// Everything else (https:, mailto:, tel:, "#") and anything under /files/ (the
// PDFs) is a plain anchor: a PDF must open as a file, never as a route.
// A trailing arrow glyph in the link text is hidden from screen readers.
export function AppLink({ href, children, ...rest }: Props) {
  const isPage = href.startsWith('/') && !href.startsWith('//') && !href.startsWith('/files/');
  const content = arrowSafe(children);
  if (isPage) return <Link to={href} {...rest}>{content}</Link>;
  return <a href={href} {...rest}>{content}</a>;
}
